import React, { useState, useEffect } from "react";

import Header from "./Header";
import Post from "./Post";
import About from "./About";
import { Switch, Route } from "react-router-dom";
import CreatePost from "./CreatePost";
import PostDetails from "./PostDetails";
import SignUp from "./SignUp";
import SignIn from "./SignIn";
import { auth } from "./firebase";
import { useHistory } from "react-router-dom";

const App = () => {
  const [user, setUser] = useState(null);
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  useEffect(() => {
    const unsbscribe = auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // if logged
        setUser(authUser);
      } else {
        //if logged out
        setUser(null);
      }
    });
    return () => {
      // component will unmont
      unsbscribe();
    };
  }, [user, username]);

  const signUp = (event) => {
    event.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((authUser) => {
        return authUser.user.updateProfile({
          displayName: username,
        });
      })

      .catch((error) => alert(error.message));
    console.log(user);

    history.push("/");
    setUserName("");
    setEmail("");
    setPassword("");
  };

  const signIn = (event) => {
    event.preventDefault();

    auth
      .signInWithEmailAndPassword(email, password)
      .catch((error) => alert(error.message));
    history.push("/");
    setEmail("");
    setPassword("");
  };

  return (
    <div className='bg-color h-full'>
      <Header user={user} />

      <div className='app__body'>
        <Switch>
          <Route exact path='/' component={Post} />
          <Route path='/about' component={About} />
          <Route path='/create' render={() => <CreatePost user={user} />} />
          <Route
            path='/post/:id'
            render={(para) => <PostDetails user={user} {...para} />}
          />
          <Route
            path='/signup'
            render={() => (
              <SignUp
                signUp={signUp}
                username={username}
                setUserName={setUserName}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
              />
            )}
          />
          <Route
            path='/signin'
            render={() => (
              <SignIn
                signIn={signIn}
                username={username}
                setUserName={setUserName}
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
              />
            )}
          />
        </Switch>
      </div>
    </div>
  );
};

export default App;
